export default __webpack_public_path__ + "static/media/home_carousel_1.86783aff.jpg";